import {Injectable}    from '@angular/core';
import {Headers, Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Rx';

import {Documento} from './documento';

import myGlobals = require('../config');
import {Subject} from "rxjs/Subject";
import {RegAlarma} from "../regAlarma/regAlarma";

@Injectable()
export class DocumentoService {

    private documentoUrl = myGlobals.default.BASE_URL + '/documento/';  // URL to web api
    private documentos = new Subject<[Documento]>();
    documentos$ = this.documentos.asObservable();

    constructor(private http: Http) {
    }

    //Obtener todas las documentos
    getDocumentos() {
        return this.http.get(this.documentoUrl)
            .map((response) => {
                this.documentos.next(response.json());
                return response.json();
            });
    }

    //Obtener una documento
    getDocumento(_id: string): Observable<Documento> {
        return this.http.get(this.documentoUrl + _id)
            .map((response) => response.json());
    }

    synchronizeDrive(): any {
        return this.http.post(this.documentoUrl + "synchronizeDrive", null);
    }

    // Informe resumen
    public getDocumentoFile(_id: string): Observable<any> {
        let headers = new Headers({
            'Content-Type': 'application/json;charset=UTF-8',
            // 'Accept': 'application/pdf'
        });
        headers.append('dataType', 'json');
        // var sucursalStr = JSON.stringify(reporte);
        let requestOptions = {headers: headers, responseType: 'arraybuffer'};
        return this.http
            .get(this.documentoUrl + "getFile/" + _id, requestOptions)
            .map((response) => {
                return response.text();
                // const linkSource = `data:application/pdf;base64,${response.text()}`;
                // const downloadLink = document.createElement("a");
                // const fileName = "reporteResumenBemakoha" + ".pdf";
                // downloadLink.href = linkSource;
                // downloadLink.download = fileName;
                // downloadLink.click();

            });
    }

    save(documento: Documento, logo): Observable<Documento> {
        if (documento._id) {
            return this.put(documento,logo);
        }
        //Seteo estado activo
        documento.estado = true;
        return this.post(documento, logo);
    }

    //Desactivar documento
    delete(documento: Documento) {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        let url = `${this.documentoUrl}/${documento._id}`;

        return this.http
            .delete(url, {headers: headers})
            .map((response) => response.json());
    }

    // Agregar nueva documento
    private post(documento: Documento, logo): Observable<Documento> {
        var formData = new FormData();
        formData.append("logo", logo);
        formData.append("documento", JSON.stringify(documento));
        let headers = new Headers();
        headers.append('enctype', "multipart/form-data");
        return this.http
            .post(this.documentoUrl, formData, {headers: headers})
            .map((response) => response.json());
    }

    // Actualizar documento
    private put(documento: Documento, logo) {
        documento.logo = null;
        var formData = new FormData();
        formData.append("logo", logo);
        formData.append("documento", JSON.stringify(documento));
        let headers = new Headers();
        headers.append('enctype', "multipart/form-data");
        ;

        let url = `${this.documentoUrl}/${documento._id}`;

        return this.http
            .put(url, formData, {headers: headers})
            .map((response) => response.json());
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/documento/documento.service.ts